import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexFill,
  ApexStroke,
} from "ng-apexcharts";
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { BsDatepickerConfig, BsDatepickerViewMode } from 'ngx-bootstrap/datepicker';
import { BehaviorSubject, Subject } from "rxjs";
import { ChartService } from "./chart.service";
import { ToastrService } from "ngx-toastr";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js/auto';
import { environment } from "../../../environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { MatCalendar } from "@angular/material/datepicker";
import { DateAdapter } from '@angular/material/core';
import { DateRange, MatMonthView } from '@angular/material/datepicker';
import moment, { Moment } from 'moment';
type ApexXAxis = {
  type?: "category" | "datetime" | "numeric";
  categories?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
};

// export type ChartOptions1 = {
//   series: ApexNonAxisChartSeries;
//   chart: ApexChart;
//   responsive: ApexResponsive[];
//   labels: any;
//   fill: ApexFill;
//   legend: ApexLegend;
//   stroke: ApexStroke;
//   dataLabels: ApexDataLabels;
// };

export type ChartOptions1 = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
  stroke: ApexStroke;
};

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
  stroke: ApexStroke;
};
let compareStartDate: string;
let compareEndDate: string;

@Component({
  selector: "app-chart-component",
  templateUrl: "./chart-component.component.html",
  styleUrls: ["./chart-component.component.scss"],
})
export class ChartComponentComponent implements OnInit {
  @ViewChild('chart', { static: true }) chart!: ElementRef;
  @ViewChild('chartRound', { static: true }) chartRound!: ElementRef;
  @ViewChild('dp1', { static: true }) dp1!: BsDatepickerDirective;
  @ViewChild('dp2', { static: true }) dp2!: BsDatepickerDirective;
  @ViewChild('dp3', { static: true }) dp3!: BsDatepickerDirective;
  @ViewChild('dp4', { static: true }) dp4!: BsDatepickerDirective;
  firstMonth: any;
  secondMonth: any;
  firstMonth1: any;
  secondMonth1: any;
  bucketurl = environment.bucketUrl;
  // chart!: ChartComponent;
  visible: boolean = false
  visible2: boolean = false
  public chartOptions: Partial<ChartOptions>;
  public chartOptions1: Partial<ChartOptions1>;

  // chartRound!: ChartComponent;
  isLoading: Subject<boolean> = new Subject<boolean>();
  carddata: any;

  // bsValue: Date = new Date(2017, 7);
  minMode: BsDatepickerViewMode = 'month';
  bsConfig!: Partial<BsDatepickerConfig>;
  // firstMonth!: Date;
  // secondMonth!: Date;

  public cards: { title: string; value: number, icon: string }[] = [
    { title: "All Leads", value: 0, icon: 'all-leads' },
    { title: "Touched", value: 0, icon: 'touched' },
    { title: "Untouched", value: 0, icon: 'untouched' },
    { title: "Follow Up", value: 0, icon: 'booked' },
    { title: "Junk", value: 0, icon: 'junk-leads' },
    { title: "Sales Qualified", value: 0, icon: 'sals-qualified' },
    { title: "Non Sales", value: 0, icon: 'non-sales-qualified' },
    { title: "No Response", value: 0, icon: 'follow-up' },
  ];

  public leads: { title: string; value: number; subTitle: string, icon: string }[] = [
    {
      title: "Leads to Qualified",
      value: 0,
      subTitle: "Less than Last month",
      icon: 'leads-to-qualified'
    },
    {
      title: "Leads to Junk",
      value: 0,
      subTitle: "More than Last month",
      icon: 'lead-to-lost'
    },
    {
      title: "Leads to Non - Sales",
      value: 0,
      subTitle: "Less than Last month",
      icon: 'lead-to-nonsale'
    },
  ];
  today: Date = new Date(); // Initialize today's date

  startDate: any;
  endDate: any;
  selectedRange!: { start: string; end: string };
  chartSeries: any;
  nodata: boolean = false;
  nodata2: boolean = false;
  assignAllleads: any;
  lostAllleads: any;
  nonsalesAllleads: any;
  touchedUntouchedleads: any;
  private formatDate(date: Date): string {
    return `${date.getFullYear()}-${this.padZero(date.getMonth() + 1)}-${this.padZero(date.getDate())}T${this.padZero(date.getHours())}:${this.padZero(date.getMinutes())}:${this.padZero(date.getSeconds())}.000Z`;
  }

  private padZero(value: number): string {
    return (value < 10 ? '0' : '') + value;
  }


  constructor(private _dateAdapter: DateAdapter<Moment>, private chartService: ChartService, private toastr: ToastrService, public dialog: MatDialog) {
    this.chartOptions = {
      series: [
        {
          name: 'Leads',
          data: [],
        },
        {
          name: 'Revenue',
          data: [],
        },
      ],
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#333']
        },
        offsetY: -20
      },
      chart: {
        height: 350,
        type: "bar",
        events: {
          click: function (chart, w, e) {
          },
        },
        toolbar: {
          show: false
        }
      },
      // colors: ["#14C9C9", "#14C9C9", "#14C9C9", "#14C9C9", "#14C9C9"],
      plotOptions: {
        bar: {
          columnWidth: "50px",
          distributed: true,
          borderRadius: 3,
          dataLabels: {
            position: 'top',
          },
        },
      },
      // dataLabels: {
      //   enabled: true,
      //   offsetY: -16,
      //   style: {
      //     colors: ['#000'],
      //   },
      // },
      legend: {
        show: false
      },
      grid: {
        borderColor: '#D9D9D9',
        strokeDashArray: 3,
      },
      xaxis: {
        categories: [['Assigned'], ['Test Ride'], ['Booked'], ['Retailed'], ['Lost']],

        labels: {
          style: {
            // colors: ['#1890FF','#1890FF','#1890FF','#1890FF','#1890FF'],
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        max: function (max: any) {
          return Math.ceil(max * 1.1); // Round up to ensure integer values
        },
        min: 0,  // Ensure the y-axis starts from 0
        labels: {
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
    };
    this.chartOptions1 = {
      series: [
        {
          name: 'Leads',
          data: [],
        },
        {
          name: 'Revenue',
          data: [],
        },
      ],
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#333']
        },
        offsetY: -20
      },
      chart: {
        height: 350,
        type: "bar",
        events: {
          click: function (chart, w, e) {
          },
        },
        toolbar: {
          show: false
        }
      },
      // colors: ["#14C9C9", "#14C9C9", "#14C9C9", "#14C9C9", "#14C9C9"],
      plotOptions: {
        bar: {
          columnWidth: "50px",
          distributed: true,
          borderRadius: 3,
          dataLabels: {
            position: 'top',
          },
        },
      },
      legend: {
        show: false
      },
      grid: {
        borderColor: '#D9D9D9',
        strokeDashArray: 3,
      },
      xaxis: {
        categories: [],

        labels: {
          style: {
            // colors: ['#1890FF','#1890FF','#1890FF','#1890FF','#1890FF'],
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        max: function (max: any) {
          return Math.ceil(max * 1.1); // Round up to ensure integer values
        },
        min: 0,  // Ensure the y-axis starts from 0
        labels: {
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
    };
  }

  ngOnInit(): void {
    let filterObject:any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      if (filterObject.startDate) {
        this.startDate = new Date(filterObject.startDate);
        this.endDate = new Date(filterObject.endDate);
        this.dateRange = new DateRange(this.startDate, this.endDate);
        this.selectedButton = filterObject.selectedButton;

        let startDate = this.formatDate(new Date(this.startDate.getTime()));
        let endDate = this.formatDate(new Date(this.endDate.getTime() + 24 * 60 * 60 * 1000 - 1));
        let request = {
      "startDate": startDate,
      "endDate": endDate
    };
 const selectMonth = new Date(this.startDate);
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
    this.getCardData(request);
    this.getDonutData(request);
    this.getChartData(request);
    this.getChartDataSales(request);
      } else {
        this.selectThisMonth();
      }
    } else {
      this.selectThisMonth();
    }
    this.bsConfig = {
      adaptivePosition: true,
      keepDatesOutOfRules: true,
      minMode: 'month' as BsDatepickerViewMode,
      dateInputFormat: 'MMMM YYYY',
      maxDate: new Date() // restricts to the current month
    };
    // this.getCardData({ startDate: '', endDate: '' });
    // this.getDonutData({ startDate: '', endDate: '' });
    // this.getChartData({ startDate: '', endDate: '' });
    this.getPercentageData({ startDate: '', endDate: '' });

    Chart.register(ChartDataLabels);

    this.leadLostChart();
    this.leadAssignedChart();
    this.leadNonSalesChart();
    this.assignedChart();
  }

  onclick() {
    this.visible = !this.visible
  }
  onclick2() {
    this.visible2 = !this.visible2
  }

  getCardData(request: { startDate: string, endDate: string }) {
    this.isLoading.next(true);

    this.chartService.getCardData(request).subscribe(
      (response: any) => {
        let responseData = response.body;

        if (responseData.responseCode == 200) {
          // Update each card's value based on the response data
          this.cards.forEach(card => {
            switch (card.title) {
              case "Sales Qualified":
                card.value = responseData.data["Sales Qualified"];
                break;
              case "Non Sales":
                // Transform "Non Sales Qualified" to "Non Sales"
                // card.title = "Non Sales";
                card.value = responseData.data["Non Sales Qualified"];
                break;
              case "No Response":
                // Transform "Non Sales Qualified" to "Non Sales"
                // card.title = "Non Sales";
                card.value = responseData.data["NoResponse"] ? responseData.data["NoResponse"] : 0;
                break;
              default:
                card.value = responseData.data[card.title];
                break;
            }
          });
          // Set isLoading to false after updating cards
          this.isLoading.next(false);
        } else {
          this.isLoading.next(false);
          this.toastr.error(response.body.responseMessage);
        }
      },
      (err: any) => {
        this.isLoading.next(false);
        this.toastr.error('An error occurred while fetching data.');
      }
    );
  }

  getPercentageData(request: { startDate: string, endDate: string }) {
    this.chartService.getPercentageData(request).subscribe(
      (response: any) => {
        let responseData = response.body;

        if (responseData.responseCode == 200) {
          this.leads[0].value = Math.round(responseData.data.qualifiedStage ?? 0);
          this.leads[1].value = Math.round(responseData.data.lostStage ?? 0);
          this.leads[2].value = Math.round(responseData.data.nonSalesStage ?? 0);
          this.updateSubTitles();
        } else {
          this.toastr.error(response.body.responseMessage);
        }
      },
      (err: any) => {
        this.toastr.error('An error occurred while fetching data.');
      }
    );
  }

  getChartData(request: { startDate: string, endDate: string }) {
    this.chartService.getChartData(request).subscribe(
      (response: any) => {
        let responseData = response.body.data?.currentData;

        let resoponsecompareDataA = response.body.data?.monthAData;

        let resoponsecompareDataB = response.body.data?.monthBData;

        // Initialize an empty array for chartOptions.series
        this.chartOptions.series = [];

        // Check and add comparison data A if available
        if (resoponsecompareDataA && Object.keys(resoponsecompareDataA).length > 0) {
          let monthNameA = moment(this.firstMonth).format('MMM');
          this.chartOptions.series.push({
            name: `${monthNameA}`,
            data: [
              { x: 'Assigned', y: resoponsecompareDataA.Assigned || 0, fillColor: '#7A62E4' },
              { x: 'Test Drive', y: resoponsecompareDataA['Test Drive'] || 0, fillColor: '#7A62E4' },
              { x: 'Booked', y: resoponsecompareDataA.Booked || 0, fillColor: '#7A62E4' },
              { x: 'Retailed', y: resoponsecompareDataA.Retailed || 0, fillColor: '#7A62E4' },
              { x: 'Lost', y: resoponsecompareDataA['Lost'] || 0, fillColor: '#7A62E4' },
            ]
          });
        }

        // Check and add comparison data B if available
        if (resoponsecompareDataB && Object.keys(resoponsecompareDataB).length > 0) {
          let monthNameB = moment(this.secondMonth).format('MMM');
          this.chartOptions.series.push({
            name: `${monthNameB}`,
            data: [
              { x: 'Assigned', y: resoponsecompareDataB.Assigned || 0, fillColor: '#ff5c7f' },
              { x: 'Test Drive', y: resoponsecompareDataB['Test Drive'] || 0, fillColor: '#ff5c7f' },
              { x: 'Booked', y: resoponsecompareDataB.Booked || 0, fillColor: '#ff5c7f' },
              { x: 'Retailed', y: resoponsecompareDataB.Retailed || 0, fillColor: '#ff5c7f' },
              { x: 'Lost', y: resoponsecompareDataB['Lost'] || 0, fillColor: '#ff5c7f' },
            ],
          });
        }

        // If no comparison data, add main data (Leads) series
        if ((!resoponsecompareDataA || Object.keys(resoponsecompareDataA).length === 0) &&
          (!resoponsecompareDataB || Object.keys(resoponsecompareDataB).length === 0)) {
          this.chartOptions.series.push({
            name: 'Leads',
            data: [
              { x: 'Assigned', y: responseData.Assigned || 0, fillColor: '#7A62E4' },
              { x: 'Test Drive', y: responseData['Test Drive'] || 0, fillColor: '#7A62E4' },
              { x: 'Booked', y: responseData.Booked || 0, fillColor: '#7A62E4' },
              { x: 'Retailed', y: responseData.Retailed || 0, fillColor: '#7A62E4' },
              { x: 'Lost', y: responseData['Lost'] || 0, fillColor: '#7A62E4' },

            ]
          });
        }
        // Check if all data points are zero
        const allZero = this.chartOptions.series.every((series: any) =>
          series.data.every((dataPoint: any) => dataPoint.y === 0)
        );
        if (allZero) {
          this.nodata = true;
        } else {
          this.nodata = false;
        }
        if (response.responseCode == 200 && responseData) {
        }
      },
      (err: any) => {
        this.toastr.error('An error occurred while fetching data.');
      }
    );
  }
  getChartDataSales(request: { startDate: string, endDate: string }) {
    this.chartService.getChartDataSales(request).subscribe(
      (response: any) => {
        let responseData = response.body.data?.currentData;
        // console.log(responseData);
        // Initialize an empty array for chartOptions1.series
        this.chartOptions1.series = [];

        let resoponsecompareDataB = response.body.data?.monthBData;
        // console.log(resoponsecompareDataB, 'resoponsecompareDataB');

        // Check and add comparison data B if available
        if (resoponsecompareDataB && Object.keys(resoponsecompareDataB).length > 0) {
          let monthNameB = moment(this.secondMonth1).format('MMM');
          let monthcountB = Object.keys(resoponsecompareDataB).map(key => ({
            x: key,
            y: resoponsecompareDataB[key] || 0,
            fillColor: '#7A62E4'
          }));
          console.log(monthcountB);

          this.chartOptions1.series.push({
            name: `${monthNameB}`,
            // data: [
            //   { x: 'Bhan Test', y: resoponsecompareDataB['Bhan Test'] || 0, fillColor: '#7A62E4' },
            //   { x: 'Rohit salesmanager', y: resoponsecompareDataB['Rohit salesmanager'] || 0, fillColor: '#7A62E4' },
            // ],
            data: monthcountB
          });
        }

        let resoponsecompareDataA = response.body.data?.monthAData;

        // Check and add comparison data A if available
        if (resoponsecompareDataA && Object.keys(resoponsecompareDataA).length > 0) {
          let monthNameA = moment(this.firstMonth1).format('MMM');
          let monthcountA = Object.keys(resoponsecompareDataA).map(key => ({
            x: key,
            y: resoponsecompareDataA[key] || 0,
            fillColor: '#ff5c7f'
          }));
          console.log(monthcountA);

          this.chartOptions1.series.push({
            name: `${monthNameA}`,
            // data: [
            //   { x: 'Bhan Test', y: resoponsecompareDataA['Bhan Test'] || 0, fillColor: '#ff5c7f' },
            //   { x: 'Rohit salesmanager', y: resoponsecompareDataA['Rohit salesmanager'] || 0, fillColor: '#ff5c7f' },
            // ]
            data: monthcountA
          });
        }

        // If no comparison data, add main data (Leads) series
        if ((!resoponsecompareDataA || Object.keys(resoponsecompareDataA).length === 0) &&
          (!resoponsecompareDataB || Object.keys(resoponsecompareDataB).length === 0)) {
          // Initialize an empty array for the data series
          const dataSeries = [];

          // Iterate over currentData to build the dataSeries array dynamically
          for (const [key, value] of Object.entries(responseData)) {
            dataSeries.push({
              x: key,
              y: value || 0,
              fillColor: '#7A62E4'
            });
          }

          // Push the series to chartOptions1
          this.chartOptions1.series.push({
            name: 'Leads',
            data: dataSeries
          });
        }
        // Check if all data points are zero
        const allZero = this.chartOptions1.series.every((series: any) =>
          series.data.every((dataPoint: any) => dataPoint.y === 0)
        );
        if (allZero) {
          this.nodata2 = true;
        } else {
          this.nodata2 = false;
        }
        if (response.responseCode == 200 && responseData) {
        }
      },
      (err: any) => {
        this.toastr.error('An error occurred while fetching data.');
      }
    );
  }

  compareMonths(): void {
    if (this.firstMonth && this.secondMonth) {

      let compareStartDate = new Date(this.firstMonth);
      compareStartDate.setUTCHours(0, 0, 0, 0);
      let compareEndDate = new Date(this.secondMonth);
      compareEndDate.setUTCHours(0, 0, 0, 0);


      let request = {
        startDate: '',
        endDate: '',
        compareStartDate,
        compareEndDate
      };

      this.getChartData(request);
    } else {
    }
  }
  compareMonths1(): void {
    if (this.firstMonth1 && this.secondMonth1) {

      let compareStartDate = new Date(this.firstMonth1);
      compareStartDate.setUTCHours(0, 0, 0, 0);
      let compareEndDate = new Date(this.secondMonth1);
      compareEndDate.setUTCHours(0, 0, 0, 0);


      let request = {
        startDate: '',
        endDate: '',
        compareStartDate,
        compareEndDate
      };

      this.getChartDataSales(request);
    } else {
    }
  }

  clearComparison(): void {
    let request = {
      startDate: this.startDate,
      endDate: this.endDate
    };

    // Reset bsValue of dp1 and dp2 to undefined
    if (this.dp1) {
      this.dp1.bsValue = undefined;
    }
    if (this.dp2) {
      this.dp2.bsValue = undefined;
    }

    // Clear any selected start and end dates
    this.firstMonth = undefined;
    this.secondMonth = undefined;

    // Fetch chart data with empty start and end dates
    this.getChartData(request);
  }
  clearComparison1(): void {
    let request = {
      startDate: this.startDate,
      endDate: this.endDate
    };

    // Reset bsValue of dp1 and dp2 to undefined
    if (this.dp3) {
      this.dp3.bsValue = undefined;
    }
    if (this.dp4) {
      this.dp4.bsValue = undefined;
    }

    // Clear any selected start and end dates
    this.firstMonth1 = undefined;
    this.secondMonth1 = undefined;

    // Fetch chart data with empty start and end dates
    this.getChartDataSales(request);
  }

  onDateRangeChange(): void {
    if (this.startDate && this.endDate) {
      // Adjust endDate to be inclusive of the selected date
      let startDate = this.formatDate(new Date(this.startDate.getTime()));
      let endDate = this.formatDate(new Date(this.endDate.getTime() + 24 * 60 * 60 * 1000 - 1));
      let request = {
        "startDate": startDate,
        "endDate": endDate
      };

      this.getCardData(request);
      // this.getPercentageData(request);
      this.getDonutData(request);
      this.getChartData(request);
      this.getChartDataSales(request);

    } else {
      this.getCardData({ startDate: '', endDate: '' });
      // this.getPercentageData({ startDate: '', endDate: '' });
      this.getDonutData({ startDate: '', endDate: '' });
      this.getChartData({ startDate: '', endDate: '' });
      this.getChartDataSales({ startDate: '', endDate: '' });
    }
  }




  updateSubTitles() {
    this.leads.forEach(lead => {
      if (lead.value < 0) {
        lead.subTitle = "Less than last month";
      } else if (lead.value > 0) {
        lead.subTitle = "More than last month";
      } else {
        lead.subTitle = "Equal to last month";
      }
    });
  }

  allpercentage: any = 0;
  nonsalespercentage: any = 0;
  lostpercentage: any = 0;
  assignpercentage: any = 0;
  touchedUntouched: any = 0;
  assignedLeadCount: any = 0;
  getDonutData(request: { startDate: string, endDate: string }) {
    this.chartService.getDonutData(request).subscribe(
      (response: any) => {
        let responseData = response.body;

        if (responseData.responseCode == 200) {
          let allLeads = responseData.data['All Leads'];
          let nonsales = responseData.data['Non Sales Qualified'];
          let lost = responseData.data.lost;
          let assigned = responseData.data.assigned;
          let touched = responseData.data['Touched'];
          let untouched = responseData.data['Untouched'];
          this.assignedLeadCount = assigned ? assigned : 0;
          this.assignAllleads = allLeads === 0 && assigned === 0;
          this.lostAllleads = allLeads === 0 && lost === 0;
          this.nonsalesAllleads = allLeads === 0 && nonsales === 0;
          this.touchedUntouchedleads = touched === 0 && untouched === 0;

          this.assignpercentage = Math.round((assigned / allLeads) * 100);
          this.lostpercentage = Math.round((lost / allLeads) * 100);
          this.nonsalespercentage = Math.round((nonsales / allLeads) * 100);
          this.touchedUntouched = touched + untouched;

          this.allpercentage = assigned > 0 ? Math.round((Math.max(untouched, 0) / assigned) * 100) : 0;

          if (isNaN(this.allpercentage)) {
            this.allpercentage = 0;
          }



          this.assignedData = {
            labels: ['Touched', 'UnTouched'],
            datasets: [
              {
                data: [responseData.data.Touched, responseData.data.Untouched],
                backgroundColor: [
                  '#1991FF',
                  '#F7BA1E',
                ],
              }
            ]
          };
          this.leadToNonSalesData = {
            labels: ['All Leads', 'Non Sales Qualified'],
            datasets: [
              {
                data: [responseData.data['All Leads'], responseData.data['Non Sales Qualified']],
                backgroundColor: [
                  '#15CACA',
                  '#722ED1',
                ],
              }
            ]
          }
          this.leadToLostData = {
            labels: ['All Leads', 'Junk'],
            datasets: [
              {
                data: [responseData.data['All Leads'], responseData.data['lost']],
                backgroundColor: [
                  '#9B9B9B',
                  '#1991FF',
                ],
              }
            ]
          }
          this.leadToAssignedData = {
            labels: ['All Leads', 'assigned'],
            datasets: [
              {
                data: [responseData.data['All Leads'], responseData.data['assigned']],
                backgroundColor: [
                  '#14C9C9',
                  '#165DFF',
                ],
              }
            ]
          }
        } else {
          this.toastr.error(response.body.responseMessage);
        }
      },
      (err: any) => {
        this.toastr.error('An error occurred while fetching data.');
      }
    );
  }
  leadToAssignedData: any;
  leadToAssignedOptions: any;

  leadToLostData: any;
  leadToLostOptions: any;

  leadToNonSalesData: any;
  leadToNonSalesOptions: any;

  assignedData: any
  assignedOptions: any;

  leadAssignedChart() {

    this.leadToAssignedData = {
      labels: ['Leads', 'Assigned'],
      datasets: [
        {
          data: [70, 40],
          backgroundColor: [
            '#14C9C9',
            '#165DFF',
          ],
        }
      ]
    };


    this.leadToAssignedOptions = {
      cutout: '65%',
      // responsive: true,
      // maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'chartArea',
          onClick: (e: any) => e.stopPropagation(),
          labels: {
            usePointStyle: false,
            pointStyle: 'circle',
            boxWidth: 0,
            padding: 5,
            font: {
              size: 13
            },
            color: "#A3AED0",
            textAlign: 'center',
            generateLabels: (chart: any) => {
              const datasets = chart.data.datasets;
              return chart.data.labels.map((label: any, i: any) => {
                const dataset = datasets[0];
                let capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
                return {
                  text: capitalizedLabel + ' : ' + dataset.data[i],
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.backgroundColor[i],
                  hidden: chart.getDatasetMeta(0).data[i].hidden,
                  index: i
                };
              });
            }
          },
        },
        datalabels: {
          display: false,
          color: ['white', 'white'],
          formatter: (value: number, context: any) => {
            return value;
          },
          font: {
            size: 11
          }
        }
      }
    };
  }


  leadLostChart() {

    this.leadToLostData = {
      labels: ['Leads', 'Lost'],
      datasets: [
        {
          data: [70, 30],
          backgroundColor: [
            '#1991FF',
            '#9B9B9B',
          ],
        }
      ]
    };


    this.leadToLostOptions = {
      cutout: '65%',
      // responsive: true,
      // maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'chartArea',
          onClick: (e: any) => e.stopPropagation(),
          labels: {
            usePointStyle: false,
            pointStyle: 'circle',
            boxWidth: 0,
            padding: 5,
            font: {
              size: 13,
            },
            color: "#A3AED0",
            textAlign: 'center',
            generateLabels: (chart: any) => {
              const datasets = chart.data.datasets;
              return chart.data.labels.map((label: any, i: any) => {
                const dataset = datasets[0];
                let capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
                return {
                  text: capitalizedLabel + ' : ' + dataset.data[i],
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.backgroundColor[i],
                  hidden: chart.getDatasetMeta(0).data[i].hidden,
                  index: i
                };
              });
            }
          },
        },
        datalabels: {
          display: false,
          color: 'white',
          formatter: (value: number, context: any) => {
            return value;
          },
          font: {
            size: 11
          }
        }
      }
    };
  }

  leadNonSalesChart() {

    this.leadToNonSalesData = {
      labels: ['Leads', 'Non Sales'],
      datasets: [
        {
          data: [70, 30],
          backgroundColor: [
            '#1991FF',
            '#9B9B9B',
          ],
        }
      ]
    };


    this.leadToNonSalesOptions = {
      cutout: '65%',
      // responsive: true,
      // maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'chartArea',
          onClick: (e: any) => e.stopPropagation(),
          labels: {
            usePointStyle: false,
            pointStyle: 'circle',
            boxWidth: 0,
            padding: 5,
            font: {
              size: 13
            },
            color: "#A3AED0",
            textAlign: 'center',
            generateLabels: (chart: any) => {
              const datasets = chart.data.datasets;
              return chart.data.labels.map((label: any, i: any) => {
                const dataset = datasets[0];
                let capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
                let text = `${capitalizedLabel} : ${dataset.data[i]}`;
                if (i === 1) {
                  text = 'Non Sales' + ' : ' + dataset.data[1];
                }
                // return {
                //   text: i == 0 ? `${'Leads to Non-Sales'}:${this.nonsalespercentage}%` : '',
                //   fillStyle: dataset.backgroundColor[i],
                //   strokeStyle: dataset.backgroundColor[i],
                //   index: i
                // };
                return {
                  text: text,
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.backgroundColor[i],
                  hidden: chart.getDatasetMeta(0).data[i].hidden,
                  index: i
                };
              });
            }
          },
        },
        datalabels: {
          display: false,
          color: 'white',
          formatter: (value: number, context: any) => {
            return value;
          },
          font: {
            size: 11
          }
        }
      }
    };
  }

  assignedChart() {

    this.assignedData = {
      labels: ['Touched', 'UnTouched'],
      datasets: [
        {
          data: [73, 39],
          backgroundColor: [
            '#1991FF',
            '#9B9B9B',
          ],
        }
      ]
    };


    this.assignedOptions = {
      cutout: '65%',
      // responsive: true,
      // maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'chartArea',
          align: 'center',
          onClick: (e: any) => e.stopPropagation(),
          labels: {
            usePointStyle: false,
            pointStyle: 'circle',
            boxWidth: 0,
            padding: 5,
            font: {
              size: 13
            },
            color: "#A3AED0",
            textAlign: 'center',
            generateLabels: (chart: any) => {
              const datasets = chart.data.datasets;
              const customLabels = ['Assigned']; // Your custom labels

              // Original dataset labels
              const originalLabels = chart.data.labels.map((label: any, i: any) => {
                const dataset = datasets[0];
                let capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
                return {
                  text: capitalizedLabel + ' : ' + Math.max(dataset.data[i], 0),
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.backgroundColor[i],
                  hidden: chart.getDatasetMeta(0).data[i].hidden,
                  index: i
                };
              });

              // Custom labels (no need to be from dataset)
              const additionalLabels = customLabels.map((customLabel: any, index: any) => {
                return {
                  text: customLabel + " : " + this.assignedLeadCount,  // Customize text format
                  fillStyle: '#cccccc',  // Custom color for label
                  strokeStyle: '#cccccc',
                  hidden: false,  // By default, custom labels are not hidden
                  index: originalLabels.length + index  // Continue index after original labels
                };
              });

              // Combine original and custom labels
              return [...additionalLabels, ...originalLabels];
            }
          },
        },
        datalabels: {
          display: false,
          color: 'white',
          formatter: (value: number, context: any) => {
            return value;
          },
          font: {
            size: 11
          }
        }
      }
    };
  }


  selectedButton: any = 'custom';
  @ViewChild('dateRangePicker') dateRangePickerTemplate!: TemplateRef<any>;
  @ViewChild('cancelButton') cancelButton!: ElementRef;
  @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;

  openDateRangePicker() {
    const dialogRef:any = this.dialog.open(this.dateRangePickerTemplate, { panelClass: 'modal-picker-class' });
     dialogRef.afterOpened().subscribe(() => {
    if (this.startCalendar) {
      const selectMonth = new Date(this.startDate);
      this.startCalendar.activeDate = selectMonth;
    }
  });
    setTimeout(() => {
      if (this.cancelButton) {
        this.cancelButton.nativeElement.focus();
      }

    }, 300);
  }

  selectToday() {
    const today = new Date();
    this.startDate = today;
    this.endDate = today;
    this.selectedButton = 'today';
    let startDate = this.formatDate(new Date(this.startDate.getTime()));
    let endDate = this.formatDate(new Date(this.endDate.getTime() + 24 * 60 * 60 * 1000 - 1));
    let request = {
      "startDate": startDate,
      "endDate": endDate
    };

    this.getCardData(request);
    this.getDonutData(request);
    this.getChartData(request);
    this.getChartDataSales(request);
    this.dateRange = new DateRange(this.startDate, this.endDate);
    const selectMonth = new Date();
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }

   selectLastDays(days: number, buttonLabel: string) {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    
    // Set start date as 7 days before yesterday
    this.startDate = new Date(yesterday);
    this.startDate.setDate(yesterday.getDate() - days); // 7 days excluding today
    
    this.endDate = yesterday; // Yesterday is the end date
    this.selectedButton = buttonLabel;
    this.dateRange = new DateRange(this.startDate, this.endDate);

    let startDate = this.formatDate(new Date(this.startDate.getTime()));
    let endDate = this.formatDate(new Date(this.endDate.getTime() + 24 * 60 * 60 * 1000 - 1));
      let request = {
      "startDate": startDate,
      "endDate": endDate
    };

    // this.getCardData(request);
    // this.getDonutData(request);
    // this.getChartData(request);
    // this.getChartDataSales(request);
    const selectMonth = new Date(this.startDate);
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }
  
  selectLast7Days() {
    this.selectLastDays(6, 'last7');
  }
  
  selectLast15Days() {
    this.selectLastDays(14, 'last15');
  }
  
  selectLast30Days() {
    this.selectLastDays(29, 'last30');
  }

  selectThisMonth() {
    this.selectedButton = 'thisMonth';
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.startDate = startOfMonth;
    this.endDate = today;
    let startDate = this.formatDate(new Date(this.startDate.getTime()));
    let endDate = this.formatDate(new Date(this.endDate.getTime() + 24 * 60 * 60 * 1000 - 1));
    let request = {
      "startDate": startDate,
      "endDate": endDate
    };
    this.dateRange = new DateRange(this.startDate, this.endDate);
    this.getCardData(request);
    this.getDonutData(request);
    this.getChartData(request);
    this.getChartDataSales(request);

    const selectMonth = new Date(this.startDate);
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }

  selectCustom() {
    this.selectedButton = 'custom';
    this.startDate = null;
    this.endDate = null;
    this.dateRange = new DateRange(this.startDate, this.endDate);
  }

  onStartDateChange(event: Date) {
    this.startDate = event;
  }

  onEndDateChange(event: Date) {
    this.endDate = event;
  }

  closeDialog() {
    if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
      this.toastr.error("The end date should be greater than or equal to the start date!")
    } else {
      this.selectThisMonth();
      setTimeout(() => {
        this.applyDateRange();
      }, 100)
      this.dialog.closeAll();
    }
  }

  applyDateRange() {
    // Logic to apply the date range
    if (this.startDate == null || this.endDate == null) {
      this.toastr.error("Please select a date range!");
    } else {
      if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
        this.toastr.error("The end date should be greater than or equal to the start date!")
      } else {
        let filterObject: any = {}
        if (sessionStorage.getItem('filterObject')) {
          filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
        }
        filterObject.startDate = moment(this.startDate).format('YYYY-MM-DD');
        filterObject.endDate = moment(this.endDate).format('YYYY-MM-DD');
        filterObject.selectedButton = this.selectedButton;
        sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
        this.dialog.closeAll();
        let startDate = this.formatDate(new Date(this.startDate.getTime()));
        let endDate = this.formatDate(new Date(this.endDate.getTime() + 24 * 60 * 60 * 1000 - 1));
        let request = {
          "startDate": startDate,
          "endDate": endDate
        };

        this.getCardData(request);
        this.getDonutData(request);
        this.getChartData(request);
        this.getChartDataSales(request);
      }
    }
  }

  clearDate() {
    this.selectedButton = 'thisMonth';
    this.startDate = null;
    this.endDate = null;
    this.closeDialog();
    this.getCardData({ startDate: '', endDate: '' });
    this.getDonutData({ startDate: '', endDate: '' });
    this.getChartData({ startDate: '', endDate: '' });
    this.getChartDataSales({ startDate: '', endDate: '' });
  }
  preventTyping(event: KeyboardEvent): void {
    event.preventDefault();
  }

  // Private
  _startDate: any | null = null;
  _endDate: any | null = null;

  // Set the range
  range: { start: Date | null; end: Date | null } = {
    start: moment().endOf('month').subtract(1, 'week').toDate(),
    end: moment().endOf('month').add(1, 'week').toDate()
  };

  // DateRange instance using range
  dateRange = new DateRange(this.range.start, this.range.end);

  selectedChange(date: any): void {
    if (!this._startDate) {
      this._startDate = date;
    } else if (
      !this._endDate &&
      this._dateAdapter.compareDate(date, this._startDate) >= 0
    ) {
      this._endDate = date;
    } else {
      this._startDate = date;
      this._endDate = null;
    }
    this.dateRange = new DateRange(this._startDate, this._endDate);
    this.startDate = this._startDate;
    this.endDate = this._endDate;
    console.log(this.startDate, this.endDate)
  }

   reset(){
       let filterObject:any = {}
      if (sessionStorage.getItem('filterObject')) {
        filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
        if (filterObject.startDate) {
          this.startDate = new Date(filterObject.startDate);
          this.endDate = new Date(filterObject.endDate);
          this.dateRange = new DateRange(this.startDate, this.endDate);
          this.selectedButton = filterObject.selectedButton;
        } else {
          this.selectThisMonth();
        }
      }else {
        this.selectThisMonth();
      }
    }
}
